import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Flatpickr from 'react-flatpickr';
import Select, { SelectInstance } from 'react-select';
import "flatpickr/dist/flatpickr.css";

import Tab from "Common/Components/Tab/Tab";
import { Nav } from "Common/Components/Tab/Nav";
// Icon
import { Download, Loader2, Pencil, Trash2, UploadCloud } from 'lucide-react';

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

// Image
import Dropzone from "react-dropzone";
import {
    addProduct,
    addProductImages,
    uploadProductImages,
    updateProduct,
    deleteProductImages,
    getProductSku,
    updateProductImages,
} from "helpers/backend_helper";
import { Common } from "helpers/common";
import { ProductColor } from "Common/Components/ProductColor";
import { ProductVariant } from "pages/Ecommerce/Products/ProductVariant";
import Modal from "Common/Components/Modal";
import AddGTSRate from "../GSTRates/AddGTSRate";
import { appName, GenderList, getImageUrl, ProductColors } from "constants/constants";
import moment from "moment";
import { ProductColorType } from "types/ProductColorType";
import { IMAGE_FOLDER, MULTI_BRAND } from "constants/settings";

export type AttributesOption = {
    readonly value: string
    readonly label: string
}

type Props = { onHide: () => void, onSave: (result: any) => void, masterData: any, product: any }

const HsnsacPopup = ({ show, onHide, options, onSelect, selectedValue }: {
    show: boolean,
    onHide: () => void,
    options: any[],
    onSelect: (option: any) => void,
    selectedValue: any
}) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={onHide}>
            <div className="relative w-96 max-h-[400px] bg-white rounded-lg shadow-lg" onClick={e => e.stopPropagation()}>
                <div className="p-4 border-b">
                    <h3 className="text-lg font-semibold">Select HSN-SAC</h3>
                </div>
                <div className="overflow-y-auto max-h-[300px]">
                    {options.map((option, index) => (
                        <div
                            key={index}
                            className={`px-4 py-2 cursor-pointer hover:bg-slate-100 ${selectedValue?.value === option.value ? 'bg-slate-100' : ''}`}
                            onClick={() => {
                                onSelect(option);
                                onHide();
                            }}
                        >
                            <div className="flex justify-between">
                                <span>{option.label}</span>
                                <span className="text-slate-500">GST: {option.gstRate}%</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

const AddProduct: React.FC<Props> = ({ onHide, onSave, masterData, product }) => {
    const [productData, setProductData] = useState<any>();
    const [brands, setBrands] = useState<any[]>([]);
    const [selectedCategory, setSelectedCategory] = useState<any>();
    const [selectedBrand, setSelectedBrand] = useState<any>();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showHSNSACModal, setShowHSNSACModal] = useState<boolean>(false);

    const [selectedSeasons, setSelectedSeasons] = useState<any>();
    const [selectedPackagings, setSelectedPackagings] = useState<any>();
    const [categories, setCategories] = useState<any[]>([]);
    const [productSizes, setProductSizes] = useState<any[]>([]);
    const [seasons, setSeasons] = useState<any[]>([]);
    const [packagings, setPackagings] = useState<any[]>([]);
    const [productAttributes, setProductAttributes] = useState<any[]>([]);
    const [productAttributeValues, setProductAttributeValues] = useState<any[]>([]);
    const productAttributeValueRef = useRef<SelectInstance<AttributesOption> | null>(null);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [selectedGender, setSelectedGender] = useState<any>();
    const [selectedProductAttribute, setSelectedProductAttribute] = useState<AttributesOption>();
    const [selectedProductAttributeValue, setSelectedProductAttributeValue] = useState<AttributesOption>();
    const [attributes, setAttributes] = useState<any[]>([]);
    const [attributeValList, setAttributeValList] = useState<any[]>([]);
    const [productColors, setProductColors] = useState<ProductColorType[]>([]);
    const [productImages, setProductImages] = useState<any[]>([]);
    const [productTags, setProductTags] = useState<any[]>([]);
    const [selectedTags, setSelectedTags] = useState<any[]>([]);
    const [productVariants, setProductVariants] = useState<any[]>([]);
    const [hsnsacList, setHsnsacList] = useState<any[]>([]);
    const [brandDiscount, setBrandDiscount] = useState<any>(0);

    const [selectedHsnsac, setSelectedHsnsac] = useState<any>();
    const [productId, setProductId] = useState<any>(0);
    const [loadingImage, setLoadingImage] = useState<boolean>(false);
    const [showHsnsacPopup, setShowHsnsacPopup] = useState<boolean>(false);
    const [productSku, setProductSku] = useState<any>();
    const [showColorModal, setShowColorModal] = useState<boolean>(false);
    const [editingImageIndex, setEditingImageIndex] = useState<number>(-1);
    const [tempSelectedColor, setTempSelectedColor] = useState<{
        colorCode: string;
        colorName: string;
        isMultiColor?: boolean;
        selectedColors?: any[];
    } | null>(null);



    const commonHelper = new Common();

    const generateOptions = (data: any[], labelKey: string, valueKey: string = "id") =>
        [{ value: '', label: 'Select' }, ...data.map(item => ({ value: item[valueKey], label: item[labelKey] }))];

    console.log('ProductId', productId, product)

    useEffect(() => {
        loadMasterData();
    }, [masterData, product]);

    const loadMasterData = async () => {
        if (masterData) {
            if (product?.id) {
                // disable input
                const input = document.getElementById('name') as HTMLInputElement;
                input.disabled = false;

                const checkBox = document.getElementById('chk-manual-name') as HTMLInputElement;
                checkBox.checked = true;
                setProductSku(product?.sku);
                validation.setFieldValue('sku', product?.sku);
            }

            setProductId(product?.id);
            loadDropdowns(masterData);
            await loadData();
            await loadProductDetails();
        }
    }


    const loadData = async () => {
        await loadProductColors();
        await loadProductImages();
        await calculateSetPrice(null, 'all');
        if (product?.id == 0) {
            await loadProductSku();
        }

    }

    // validation
    const validation: any = useFormik({
        enableReinitialize: product?.id ? true : false,
        initialValues: {
            name: (product && product?.name) || '',
            description: (product && product?.description) || '',
            sku: (product && product?.sku) || '',
            styleNo: (product && product?.styleNo) || '',
            brandId: (product && product?.brandId) || '',
            categoryId: (product && product?.categoryId) || '',
            seasonId: (product && product?.seasonId) || '4',
            gender: (product && product?.gender) || 'Girls',
            availableFromDate: (product && product?.availableFromDate) || moment().format('MM/DD/YYYY'),
            availableToDate: (product && product?.availableToDate) || '01/01/2030',
            publish: (product && product?.publish) || true,
            packagingId: (product && product?.packagingId) || '2',
            productTags: (product && product?.productTags) || [],
            attributes: (product && product?.attributes) || [],
            isActive: (product && product?.isActive) || true,
            colors: (product && product?.colors) || [],
            hsnsac: (product && product?.hsnsac) || '',
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please enter product name !"),
            description: Yup.string().required("Please enter description !"),
            sku: Yup.string().required("Please enter SKU (Product Code) !"),
            brandId: Yup.string().required("Please select Brand !"),
            gender: Yup.string().required("Please select gender !"),
            categoryId: Yup.string().required("Please select category !"),
            seasonId: Yup.string().required("Please select season!"),
            availableFromDate: Yup.string().required("Please select available From Date!"),
            availableToDate: Yup.string().required("Please select available To Date!"),
            attributes: Yup.array().required("Please add product attributes!"),
            colors: Yup.array().required("Please select product colors!"),
            isActive: Yup.boolean().required("Please choose yes or no!"),
            hsnsac: Yup.string().required("Please select hsnsac !"),
        }),

        onSubmit: async (values: any) => {
            console.log('onsubmit', values)

            if (!isValidData()) {
                return;
            }
            setIsSaving(true);

            // Trim the product name, SKU, and style before saving
            const trimmedValues = {
                ...values,
                name: values.name.trim(),
                sku: values.sku.trim(),
                styleNo: values.styleNo.trim()
            };

            let dataToSave = {
                ...trimmedValues,
                productTags: [
                    appName,
                    "Soft Cloths", "New Arrivals"
                ],
                attributes: attributes,
                gstRate: selectedHsnsac?.gstRate,
                hsnsac: selectedHsnsac?.label,
            };

            try {

                if (product?.id) {
                    dataToSave = { ...dataToSave, id: product?.id }
                }

                var result = await (product?.id ? updateProduct(dataToSave) : addProduct(dataToSave));
                console.log(result.data)

                if (!productData?.id) {
                    setProductId(result.data.id);
                }
                
                onSave(true);
                commonHelper.showSuccessMessage(`Product has been successfully saved.`);
                setIsSaving(false);

            } catch (error: any) {
                console.log('API-Error', error?.response?.data.message);

                commonHelper.showErrorMessage(error?.response?.data.message);
                setIsSaving(false);
            }

        },

    });



    const loadProductSku = async () => {
        const response = await getProductSku();
        console.log('productSku', response.data[0]);

        if (product?.id??0== 0) {
            console.log('loadProductSku:before', response.data[0])
            setProductSku(response.data[0]);
            validation.setFieldValue('sku', response.data[0]);
            //validation.setFieldTouched('sku', true);
        } else {
            setProductSku(product?.sku);
        }
    }

    const loadProductColors = () => {
        let defaultColors = [...ProductColors]
        defaultColors.forEach(color => color.selected = product?.colors?.some((c: string) => c.toLowerCase() === color.colorCode.toLowerCase()));
        ////console.log('uniqueColors', defaultColors, product, productColors);
        setProductColors(defaultColors);
    }

    const loadProductDetails = async () => {
        //console.log('prodId', productId, ' productData', product)
        setIsEdit(product?.id ?? 0 > 0);

        if (product) {
            try {

                //console.log('in prod load 0', product);
                setAttributes(product.attributes);
                setProductTags(product.productTags);

                let tags = product.productTags.map((item: any) => ({ value: item, label: item }));
                validation.setFieldValue('productTags', tags);

                setSelectedTags(product.productTags.map((item: any) => ({ value: item, label: item })));
                setSelectedGender({ value: product.gender, label: product.gender });

                setProductVariants(product.productsProductvariants);
            } catch (err) {
                console.error('Error loading product details', err);
            }
        }
    };

    const loadBrands = async (brandItems: any[]) => {
        const brands = [{ value: '', label: 'Select', discount: 0, hsnsac: '', gendersegment: '' }, ...brandItems.map((item: any) => ({ value: item.id, label: item.name, discount: item.discount, hsnsac: item.hsnsac, gendersegment: item.gendersegment }))];
        if (brands) {
            setBrands(brands);
            ////console.log('brands', brands)

            if (brands.length == 2) {
                const selectedBrandItem = brands.find(item => item.value !== '');
                if (selectedBrandItem) {
                    //console.log('setBrandSelection', selectedBrandItem)
                    // Set the value first, then clear validation state
                    validation.setFieldValue('brandId', selectedBrandItem.value);
                    validation.setFieldTouched('brandId', false);
                    setSelectedBrand(selectedBrandItem);
                }
            }

            if (product?.brandId) {
                setBrandSelection(brands.find(item => item.value === product.brandId));
            }
        }
    };


    const loadDropdowns = async (mData: any) => {
        try {
            //console.log('load dropdown', mData);
            loadBrands(mData.brands);
            loadCategories(mData.categories)
            loadHsnsac(mData.gstRates);
            loadPackagings(mData.productPackagings);

            loadSeasons(mData.seasons);
            setAttributeValList(mData.attributeValues);
            loadProductAttributes(mData.attributes);
            loadProductSizes(mData.productSizes);
        } catch (error: any) {
            //console.log('loadDropdowns error', error)
        }
    }


    const loadHsnsac = async (hsnsacListResponse: any[] = []) => {
        if (hsnsacList.length === 0) {
            if (hsnsacListResponse) {
                // const hsItems = [{ value: '', label: 'Select', gstRate: 0 }, ...hsnsacListResponse.map((item: any) => ({ value: item.id, label: item.hsnsac, gstRate: item.gstRate }))];
                const hsItems = [...hsnsacListResponse.map((item: any) => ({ value: item.id, label: item.hsnsac, gstRate: item.gstRate }))];

                setHsnsacList(hsItems);

                //console.log('hsnsac', hsItems, selectedBrand)
                if (product?.hsnsac) {
                    const obj = hsItems.find(item => item.label === product.hsnsac)
                    console.info('obj', obj, product.hsnsac, product.gstRate, hsItems)
                    if (obj) {
                        setSelectedHsnsac(obj);
                    } else {
                        setSelectedHsnsac({ value: product.hsnsac, label: product.hsnsac, gstRate: product.gstRate });
                    }
                    //console.log('selectedHsnsac', selectedHsnsac, product.hsnsac)
                } else if (selectedBrand?.hsnsac) {
                    console.log('selectedBrand?.hsnsac', selectedBrand?.hsnsac)
                    handleBrandSelection();
                }
            }
        }
    };


    const loadCategories = async (categoriesResponse: any[] = []) => {
        if (categories.length) return;

        try {
            const categoryItems = generateOptions(categoriesResponse, "name");
            setCategories(categoryItems);
            setSelectedCategory(categoryItems.find(item => item.value === product?.categoryId || ''));
        } catch (err) {
            console.error("Error loading categories:", err);
        }
    };

    const loadProductSizes = async (sizeResponse: any[] = []) => {
        if (productSizes.length) return;

        try {
            setProductSizes(generateOptions(sizeResponse, "name"));
        } catch (err) {
            console.error("Error loading product sizes:", err);
        }
    };


    const loadSeasons = async (seasonResponse: any[] = []) => {
        if (seasons.length) return;

        try {
            const items = generateOptions(seasonResponse, "name");
            setSeasons(items);
            const defaultSeasonId = product?.seasonId || '4';
            //console.log('Seasons items:', items);
            //console.log('Looking for seasonId:', defaultSeasonId);
            const selectedSeason = items.find(item => item.value == defaultSeasonId);
            //console.log('Found season:', selectedSeason);
            setSelectedSeasons(selectedSeason);
        } catch (err) {
            console.error("Error loading seasons:", err);
        }
    };

    const loadPackagings = async (packagingResponse: any[] = []) => {
        if (packagings.length) return;

        try {
            const items = generateOptions(packagingResponse, "name");
            setPackagings(items);
            const defaultPackagingId = product?.packagingId || '2';
            //console.log('Packaging items:', items);
            //console.log('Looking for packagingId:', defaultPackagingId);
            const selectedPackaging = items.find(item => item.value == defaultPackagingId);
            //console.log('Found packaging:', selectedPackaging);
            setSelectedPackagings(selectedPackaging);
        } catch (err) {
            console.error("Error loading packagings:", err);
        }
    };


    const loadProductAttributes = async (attributeResponse: any[] = []) => {
        if (productAttributes.length) return;

        try {
            setProductAttributes(generateOptions(attributeResponse, "name"));
        } catch (err) {
            console.error("Error loading product attributes:", err);
        }
    };

    const loadProductAttributeValues = async (attributeId: string) => {
        try {
            const filteredValues = attributeValList?.filter(item => item.attributeId === attributeId);
            setProductAttributeValues(generateOptions(filteredValues, "attributeValue"));
        } catch (err) {
            console.error("Error loading product attribute values:", err);
        }
    };

    const loadProductImages = async () => {
        try {
            if (product?.productsProductimages) {
                //setProductImages(product?.productsProductimages);
                const prodImages = product?.productsProductimages.map((item: any) => {

                    return {
                        preview: getImageUrl(item.url, 'productThumbnail') || '',
                        formattedSize: '',
                        name: item.name,
                        colorCode: item.colorCode,
                        colorName: item.colorName,
                        id: item.id
                    }
                });
                setProductImages(prodImages as never[]);
            }
        } catch (err) {
            console.error('Error loading product images', err);
        }
    }

    const deleteProductImage = async (index: number) => {
        if (!productImages.length) return;
        try {
            const { id } = productImages[index];
            await deleteProductImages(id);

            //setProductImages(productImages.filter((_, idx) => idx !== index));
            setProductImages(productImages.filter((_, idx) => idx !== index));
            commonHelper.showSuccessMessage('Image has been successfully deleted.');
        } catch (err) {
            console.error('Error deleting product image', err);
        }
    }

    const calculateSetPrice = (item: any, field: string) => {

        if (field == 'unitPrice') {
            validation.setFieldValue('unitPrice', parseFloat(item.target.value));
        } else if (field == 'packOf') {
            validation.setFieldValue('packOf', parseInt(item.target.value));
        } else if (field === 'discount') {
            validation.setFieldValue('discount', parseInt(item.target.value));
        }

        const unitPrice = validation.values.unitPrice || 0;
        const packOf = validation.values.packOf || 0;
        const discount = validation.values.discount || 0;
        const setPrice = Math.round(unitPrice * packOf * 100) / 100;
        const netPrice = setPrice - discount;
        validation.setFieldValue('setPrice', setPrice);
        validation.setFieldValue('netPrice', netPrice);

    }


    const handleProductAttributeChange = (item: any) => {
        productAttributeValueRef?.current?.clearValue();
        setSelectedProductAttribute(item)

        //console.log('selected product attribute', item)
        loadProductAttributeValues(item.value)
    }

    const handleProductAttributeValueChange = (item: any) => {
        //console.log('selected product attribute', item)
        if (item) {
            setSelectedProductAttributeValue(item)
        }
    }

    const addProductAttributes = () => {
        if (!attributes) {
            setAttributes([]);
        }

        if (attributes.filter(i => i.attribute.value === selectedProductAttribute?.value).length > 0) {
            commonHelper.showErrorMessage('Product attribute [' + selectedProductAttribute?.label + '] is already added.')
            return;
        }

        const attrs = [...attributes, { attribute: selectedProductAttribute, attributeValue: selectedProductAttributeValue }]
        setAttributes(attrs);
        //console.log('attrs', attributes)
        validation.setFieldValue('attributes', attributes)

    }

    const onAttributeDelete = (attributeId: string) => {
        setAttributes(list => list.filter((attr: any, idx) => attr.attributeValue.value !== attributeId));
        //console.log('attrs', attributes)
        validation.setFieldValue('attributes', attributes)

    }


    const handleProductColorSelection = (color: ProductColorType) => {
        // Check if trying to deselect a color that's already assigned to a variant
        if (color.selected && productVariants.length > 0) {
            const isColorAssignedToVariant = productVariants.some((variant: any) =>
                variant.colorCode?.toLowerCase() === color.colorCode?.toLowerCase()
            );

            if (isColorAssignedToVariant) {
                commonHelper.showErrorMessage(`Cannot deselect color "${color.colorName}" as it has already been assigned to a product variant. Please remove the variant first.`);
                return;
            }
        }

        const prodColors = productColors.map((item: ProductColorType) => {
            if (item.colorCode === color.colorCode) {
                return { ...item, selected: !item.selected };
            } else {
                return item;
            }
        });
        setProductColors(prodColors);

        //console.log(prodColors);
        let colors =
            prodColors?.filter(item => item.selected == true)
                .map((item: ProductColorType) => {
                    return item.colorCode;
                });

        validation.setFieldValue('colors', colors);
        setTimeout(() => {
            //console.log('colors', colors, validation.values.colors);
        }, 2000);

    }

    const handleAcceptfiles = async (files: any) => {
        if (!productId) {
            commonHelper.showErrorMessage('Please save the product first before adding images.');
            return;
        }
        setLoadingImage(true);

        try {
            files?.map((file: any) => {
                return Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    formattedSize: commonHelper.formatBytes(file.size),
                });
            });

            //console.log(files);

            const imgResults = await uploadImage(productId, files[0]);

            //console.log(imgResults);

            const newFile = {
                preview: getImageUrl(imgResults?.url ?? '', 'productThumbnail') || '',
                formattedSize: '',
                name: imgResults?.name,
                id: imgResults?.id ?? 0
            }

            const selectedFiles = [...productImages, ...[newFile]]
            //productImages.push(files as never);
            setProductImages(selectedFiles as never[]);

            //console.log(selectedFiles);
            validation.setFieldValue('image', files.length);
            setLoadingImage(false);
        }
        catch (error: any) {
            setLoadingImage(false);
        }
    };

    // Color picker modal handlers
    const handleEditColor = (index: number, file: any) => {
        setEditingImageIndex(index);
        setShowColorModal(true);
        setTempSelectedColor({
            colorCode: file.colorCode,
            colorName: file.colorName
        });
    };

    const handleCloseColorModal = () => {
        setShowColorModal(false);
        setEditingImageIndex(-1);
        setTempSelectedColor(null);
    };

    const handleModalColorSelection = (color: any) => {
        // if its same color in tempSelectedColor, then don't allow to select
        if (tempSelectedColor?.colorCode === color.colorCode) {
            setTempSelectedColor({ colorCode: '  ', colorName: '  ', isMultiColor: false, selectedColors: [] });
            return;
        }

        setTempSelectedColor({ colorCode: color.colorCode, colorName: color.colorName, isMultiColor: color.isMultiColor || false, selectedColors: color.selectedColors });
    };

    const handleSaveColor = async () => {
        if (!tempSelectedColor?.colorCode || editingImageIndex === -1) return;

        // For multi-color, don't check for duplicates since it's a combination
        if (!tempSelectedColor.isMultiColor) {
            // Check if the color is already assigned to another image
            const existingColorIndex = productImages.findIndex((file: any, idx: number) =>
                idx !== editingImageIndex &&
                file.colorCode?.toLowerCase() === tempSelectedColor.colorCode?.toLowerCase()
            );

            if (existingColorIndex !== -1 && tempSelectedColor?.colorCode !== '  ') {
                commonHelper.showErrorMessage(`Color "${tempSelectedColor.colorName}" is already assigned to another image. Please choose a different color.`);
                return;
            }
        }

        try {
            // Update color in productImages
            const updatedFiles = productImages.map((f: any, idx) =>
                idx === editingImageIndex
                    ? {
                        ...f,
                        colorCode: tempSelectedColor.colorCode,
                        colorName: tempSelectedColor.colorName,
                        isMultiColor: tempSelectedColor.isMultiColor,
                        selectedColors: tempSelectedColor.selectedColors
                    }
                    : f
            );
            setProductImages(updatedFiles);

            // Call API to save image with selected color
            const imgObj = {
                ...productImages[editingImageIndex] as any,
                colorCode: tempSelectedColor.colorCode,
                colorName: tempSelectedColor.colorName,
                isMultiColor: tempSelectedColor.isMultiColor,
                selectedColors: tempSelectedColor.selectedColors
            };
            //console.log('imgObj', imgObj);

            await updateProductImages(imgObj);
            commonHelper.showSuccessMessage('Image color updated successfully.');
        } catch (err) {
            commonHelper.showErrorMessage('Failed to update image color.');
        }

        handleCloseColorModal();
    };


    const handleAvailableFromDateChange = (selectedDates: any, dateStr: any, instance: any) => {
        //console.log(dateStr)
        validation.setFieldValue('availableFromDate', dateStr)
    }

    const handleAvailableToDateChange = (selectedDates: any, dateStr: any, instance: any) => {
        validation.setFieldValue('availableToDate', dateStr)
    }


    useEffect(() => {
        handleBrandSelection();
        //console.log('handleBrandSelection:end', selectedBrand, selectedHsnsac)
    }, [selectedBrand])


    const setBrandSelection = (item: any) => {
        if (item?.value) {
            //console.log('setBrandSelection:before', item)
            validation.setFieldValue('brandId', item?.value);
            validation.setFieldTouched('brandId', true); // Clear the validation error
            //console.log('setBrandSelection', item, product)
            setSelectedBrand(item);
        }
    }

    const handleBrandSelection = () => {
        if (selectedBrand) {

            const brandDiscount = Math.round(selectedBrand.discount);
            setBrandDiscount(brandDiscount);

            if (!selectedHsnsac && selectedBrand?.hsnsac) {
                const obj = hsnsacList.find(p => p.label === selectedBrand?.hsnsac)
                if (obj) {
                    const hsnsac = { value: obj.value, label: obj.label, gstRate: obj.gstRate };
                    validation.setFieldValue('hsnsac', obj.label);
                    validation.setFieldTouched('hsnsac', true);

                    setSelectedHsnsac(hsnsac);

                }
            }


            if (!selectedGender && selectedBrand?.gendersegment) {
                let obj = null;

                if (selectedBrand?.gendersegment == 'Female')
                    obj = GenderList.find(p => p.label === 'Girls');

                if (selectedBrand?.gendersegment == 'Male')
                    obj = GenderList.find(p => p.label === 'Boys');

                if (selectedBrand?.gendersegment == 'Unisex')
                    obj = GenderList.find(p => p.label === 'Unisex');

                if (obj) {
                    const gender = { value: obj.value, label: obj.label };
                    setSelectedGender(gender);
                    validation.setFieldValue('gender', obj.label);
                    validation.setFieldTouched('gender', true);
                }
            }
        }
    }


    const toggleHSNSAC = useCallback(() => {
        setShowHSNSACModal(!showHSNSACModal);
    }, [showModal]);


    const onSaveHSNSAC = (item: any) => {
        console.log('New GST', item);
        // add this item in the hnssacList
        setHsnsacList([...hsnsacList, item]);

        const hsnsac = { value: item.id, label: item.hsnsac, gstRate: item.gstRate };
        setSelectedHsnsac(hsnsac);
        setShowHSNSACModal(false);
    }

    const handleSeasonSelection = (item: any) => {
        console.log(item);
        validation.setFieldValue('seasonId', item.value);
        setSelectedSeasons(item);
    }

    const handleGenderSelection = (item: any) => {
        console.log(item);
        validation.setFieldValue('gender', item.value);
        setSelectedGender(item);
    }


    const handleProductTagsSelection = (items: any) => {
        try {

            const selectedTags = items.map((value: string): any => ({ label: value, value }));
            const selectedTagValues = items.map((item: any): any => { return item.value });
            setProductTags(selectedTagValues);
            setSelectedTags(selectedTags);
            validation.setFieldValue('productTags', selectedTags);
        } catch (err) {
            console.log(err);
        }
    }



    const isValidData = () => {

        if (productColors.filter((item: ProductColorType) => item.selected == true).length == 0) {
            commonHelper.showErrorMessage("Please select product color(s)!");
            return false;
        }
        // else if (productVariants.length == 0) {
        //     commonHelper.showErrorMessage("Please add product variant(s)!");
        //     return false;
        // }
        else if (attributes.length == 0) {
            commonHelper.showErrorMessage("Please add product attribute(s)!");
            return false;
        }
        else {
            return true;
        }
    }

    const uploadImage = async (productId: number, file: any) => {

        console.log('images to be posted', productImages);

        if (file?.formattedSize?.length > 2) {

            const imgResult = await uploadProductImages({ fileCollection: file }, IMAGE_FOLDER);
            console.log(imgResult);

            if (imgResult?.data?.rows?.length > 0) {
                let obj = {
                    name: imgResult.data.rows[0].fileName,
                    productId: productId,
                    url: imgResult.data.rows[0].fileName,
                    isActive: true,
                    key: file.preview,
                    colorCode: '  ',
                    colorName: '  ',

                }

                const imgResult2 = await addProductImages(obj);
                console.log(imgResult2);

                const imgObj = {
                    ...obj,
                    id: imgResult2?.data?.id ?? 0
                }

                return imgObj;
            }
        }
    }

    const handleCategoryChange = (e: any) => {
        if (e?.value) {
            validation.setFieldValue('categoryId', e?.value);
            setSelectedCategory(e);
            console.log(e?.value)
        }
    }

    useEffect(() => {
        constructProductName();
    }, [selectedBrand, selectedCategory, validation.values.styleNo])

    // Update form values when selected seasons and packagings change
    useEffect(() => {
        if (selectedSeasons) {
            validation.setFieldValue('seasonId', selectedSeasons.value);
        }
    }, [selectedSeasons]);

    useEffect(() => {
        if (selectedPackagings) {
            validation.setFieldValue('packagingId', selectedPackagings.value);
        }
    }, [selectedPackagings]);

    // Set default selections when options are loaded
    useEffect(() => {
        if (seasons.length > 0 && !selectedSeasons) {
            const defaultSeasonId = product?.seasonId || '4';
            const selectedSeason = seasons.find(item => item.value == defaultSeasonId);
            if (selectedSeason) {
                setSelectedSeasons(selectedSeason);
                validation.setFieldValue('seasonId', selectedSeason.value);
            }
        }
    }, [seasons, selectedSeasons, product?.seasonId]);

    useEffect(() => {
        if (packagings.length > 0 && !selectedPackagings) {
            const defaultPackagingId = product?.packagingId || '2';
            const selectedPackaging = packagings.find(item => item.value == defaultPackagingId);
            if (selectedPackaging) {
                setSelectedPackagings(selectedPackaging);
                validation.setFieldValue('packagingId', selectedPackaging.value);
            }
        }
    }, [packagings, selectedPackagings, product?.packagingId]);

    const constructProductName = () => {

        let nameArray: string[] = [];
        if (selectedCategory) {
            nameArray.push(selectedCategory.label);
        }
        if (selectedBrand && MULTI_BRAND) {
            nameArray.push(selectedBrand.label);
        }
        if (validation.values.styleNo) {
            nameArray.push(validation.values.styleNo);
        }
        // const categoryName = selectedCategory?.label;
        // const brandName = selectedBrand?.label;
        // const styleName = validation.values.styleNo;
        // const productName = [categoryName, brandName, styleName].filter(Boolean).join(' ');

        const productName = nameArray.join(' ');

        const input = document.getElementById('name') as HTMLInputElement;
        if (input?.disabled) {
            validation.setFieldValue('name', productName);
        }
    };

    const handleStyleChange = (e: any) => {
        validation.setFieldValue('styleNo', e.target.value);
        //constructProductName();
    }


    useEffect(() => {
        document.body.classList.remove('overflow-hidden');
    }, []);

    // Memoize props to prevent unnecessary re-renders of ProductVariant
    const memoizedProductColors = useMemo(() =>
        productColors?.filter(item => item.selected == true) || [],
        [productColors]
    );

    const memoizedProductName = useMemo(() =>
        validation.values.name,
        [validation.values.name]
    );

    const memoizedProductSKU = useMemo(() =>
        validation.values.sku,
        [validation.values.sku]
    );

    // Create combined items array for ProductColorImage component
    const combinedColorItems = useMemo(() => {
        const items: Array<{
            type: 'image' | 'color';
            id: string | number;
            colorCode: string;
            colorName: string;
            imageUrl?: string;
            imageName?: string;
            selected?: boolean;
            isMultiColor?: boolean;
            selectedColors?: any[];
        }> = [];

        // Add images with colors (only if the color is selected)
        productImages?.filter((image: any) => image.colorCode).forEach((image: any, index: number) => {
            const selectedColor = productColors.find(c =>
                c.colorCode.toLowerCase() === image.colorCode?.toLowerCase() && c.selected
            );

            if (selectedColor || image.colorName === 'Multi Color') {
                items.push({
                    type: 'image',
                    id: index,
                    colorCode: image.colorCode,
                    colorName: image.colorName,
                    imageUrl: image.preview,
                    imageName: image.name,
                    selected: image.selected
                });
            }
        });

        // Add remaining selected colors without images
        productColors?.filter((color: ProductColorType) => {
            const hasImage = productImages?.some((image: any) =>
                image.colorCode?.toLowerCase() === color.colorCode?.toLowerCase()
            );
            return !hasImage && color.selected;
        }).forEach((color: ProductColorType) => {
            items.push({
                type: 'color',
                id: color.colorCode,
                colorCode: color.colorCode,
                colorName: color.colorName,
                selected: color.selected
            });
        });

        // Only add multi-color option if there is an image tagged as multi-color
        // const hasMultiColorImage = productImages?.some(
        //     (img: any) => img.colorName === 'Multi Color' || img.colorCode === 'multi'
        // );
        // if (hasMultiColorImage) {
        //     const selectedColors = productColors?.filter(c => c.selected) || [];
        //     items.push({
        //         type: 'image',
        //         id: 'multi',
        //         colorCode: 'multi',
        //         colorName: 'Multi Color',
        //         selected: false,
        //         isMultiColor: true,
        //         selectedColors: selectedColors
        //     });
        // }

        console.log('combinedColorItems', items);
        return items;
    }, [productImages, productColors]);

    return (
        <React.Fragment>
            {/* <ToastContainer closeButton={false} limit={5} /> */}
            <div className="mt-3" >
                <div className="card-body">
                    <Tab.Container defaultActiveKey="productDetailBorderTop">

                        <Nav className="flex flex-wrap w-full text-sm font-medium text-center border-b border-slate-200 dark:border-zink-500 nav-tabs">
                            <Nav.Item eventKey="productDetailBorderTop" className="group">
                                <a href="#!" data-tab-toggle data-target="productDetailBorderTop"
                                    className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border border-transparent border-t-2 group-[.active]:text-custom-500 group-[.active]:border-slate-200 dark:group-[.active]:border-zink-500 group-[.active]:border-t-custom-500 dark:group-[.active]:border-t-custom-500 group-[.active]:border-b-white dark:group-[.active]:border-b-zink-700 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 -mb-[1px]">
                                    Product Detail
                                </a>
                            </Nav.Item>
                            <Nav.Item eventKey="productImageBorderTop" className="group">
                                <a href="#!" data-tab-toggle data-target="productImageBorderTop" className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border border-transparent border-t-2 group-[.active]:text-custom-500 group-[.active]:border-slate-200 dark:group-[.active]:border-zink-500 group-[.active]:border-t-custom-500 dark:group-[.active]:border-t-custom-500 group-[.active]:border-b-white dark:group-[.active]:border-b-zink-700 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 -mb-[1px]">
                                    Images
                                </a>
                            </Nav.Item>
                            <Nav.Item eventKey="productVariantBorderTop" className="group">
                                <a href="#!" data-tab-toggle data-target="settingBorderTop" className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border border-transparent border-t-2 group-[.active]:text-custom-500 group-[.active]:border-slate-200 dark:group-[.active]:border-zink-500 group-[.active]:border-t-custom-500 dark:group-[.active]:border-t-custom-500 group-[.active]:border-b-white dark:group-[.active]:border-b-zink-700 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 -mb-[1px]">
                                    Variants
                                </a>
                            </Nav.Item>
                        </Nav>

                        <Tab.Content className="mt-5 tab-content">
                            <Tab.Pane eventKey="productDetailBorderTop" id="productDetailBorderTop">
                                <form action="#!" autoComplete="off" onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}>
                                    <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5"  >
                                        <div className="xl:col-span-8">
                                            <div className="card bg-custom-50 dark:bg-custom-500/200">
                                                <div className="card-body">
                                                    <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12">
                                                        <div className="xl:col-span-4">
                                                            <label htmlFor="categoryId" className="inline-block mb-2 text-base font-medium">Category</label>
                                                            <Select
                                                                className="border-slate-400 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                                                options={categories}
                                                                value={selectedCategory}
                                                                defaultValue={selectedCategory}
                                                                isSearchable={true} // To disable search
                                                                name="categoryId"
                                                                id="categoryId"
                                                                onChange={e => { handleCategoryChange(e) }}

                                                            />
                                                            {validation.touched.categoryId && validation.errors.categoryId ? (
                                                                <div id="categoryId-error" className="mt-1 text-sm text-red-500">{validation.errors.categoryId}</div>
                                                            ) : null}
                                                        </div>
                                                        <div className="xl:col-span-4">
                                                            <label htmlFor="brandId" className="inline-block mb-2 text-base font-medium">Brand {validation.values.brandId}</label>
                                                            <Select
                                                                className="border-slate-400 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                                                options={brands}
                                                                value={selectedBrand}
                                                                defaultValue={selectedBrand}
                                                                isSearchable={true} // To disable search
                                                                name="brandId"
                                                                id="brandId"
                                                                onChange={e => { setBrandSelection(e); }}
                                                            />
                                                            {validation.touched.brandId && validation.errors.brandId ? (
                                                                <div id="brandId-error" className="mt-1 text-sm text-red-500">{validation.errors.brandId}</div>
                                                            ) : null}
                                                        </div>
                                                        <div className="xl:col-span-4">
                                                            <label htmlFor="styleNo" className="inline-block mb-2 text-base font-medium">Style No</label>
                                                            <input type="text" id="styleNo"
                                                                className="form-input border-slate-400 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                                                placeholder="Enter Style Number"
                                                                onChange={handleStyleChange}
                                                                //onBlur={validation.handleBlur}
                                                                value={validation.values.styleNo || ""}
                                                                autoComplete="off"
                                                            />
                                                            {validation.touched.styleNo && validation.errors.styleNo ? (
                                                                <div id="styleNo-error" className="mt-1 text-sm text-red-500">{validation.errors.styleNo}</div>
                                                            ) : null}
                                                        </div>

                                                        <div className="xl:col-span-8">
                                                            <div className="flex items-center">
                                                                <label htmlFor="name" className="inline-block mb-2 text-base font-medium mr-2">
                                                                    Product Name
                                                                </label>
                                                                <div className="flex items-center mb-2 ml-2">
                                                                    <input type="checkbox" id="chk-manual-name"
                                                                        className=" ml-2 mr-2 size-4 border rounded-sm appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-custom-500 checked:border-custom-500 dark:checked:bg-custom-500 dark:checked:border-custom-500 checked:disabled:bg-custom-400 checked:disabled:border-custom-400" onChange={(e) => {
                                                                            const input = document.getElementById('name') as HTMLInputElement;
                                                                            input.disabled = !e.target.checked;
                                                                            if (e.target.checked) {
                                                                                input.focus();
                                                                            }
                                                                        }} />
                                                                    <label htmlFor="chk-manual-name" className="text-base font-medium">Enter Manually</label>
                                                                </div>

                                                            </div>


                                                            <input type="text" id="name"
                                                                onChange={validation.handleChange}
                                                                // onBlur={validation.handleBlur}
                                                                value={validation.values.name || ""}
                                                                autoComplete="off"
                                                                disabled

                                                                className="form-input border-slate-400 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-200 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Product title" />
                                                            {validation.touched.name && validation.errors.name ? (
                                                                <div id="name-error" className="mt-1 text-sm text-red-500">{validation.errors.name}</div>
                                                            ) : null}
                                                        </div>
                                                        <div className="xl:col-span-4">
                                                            <label htmlFor="sku" className="inline-block mb-2 text-base font-medium">SKU (Product Code)</label>
                                                            <div className="relative">
                                                                <input type="text" id="sku"
                                                                    className="form-input border-slate-400 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 pr-10"
                                                                    placeholder="Enter SKU Number"
                                                                    onChange={validation.handleChange}
                                                                    //onBlur={validation.handleBlur}
                                                                    value={validation.values.sku || ""}
                                                                    autoComplete="off"
                                                                />
                                                                {validation.values.sku && (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            validation.setFieldValue('sku', '');
                                                                            validation.setFieldTouched('sku', false);
                                                                        }}
                                                                        className="absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400 hover:text-slate-600 dark:text-zink-200 dark:hover:text-zink-100"
                                                                    >
                                                                        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                                        </svg>
                                                                    </button>
                                                                )}
                                                            </div>
                                                            {validation.touched.sku && validation.errors.sku ? (
                                                                <div id="sku-error" className="mt-1 text-sm text-red-500">{validation.errors.sku}</div>
                                                            ) : null}
                                                        </div>

                                                        <div className="xl:col-span-8">
                                                            <div>
                                                                <label htmlFor="description" className="inline-block mb-2 text-base font-medium">Description</label>
                                                                <input type="text" className="form-input border-slate-400 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                                                    id="description" placeholder="Enter Description"
                                                                    onChange={validation.handleChange}
                                                                    //onBlur={validation.handleBlur}
                                                                    value={validation.values.description || ""}
                                                                    autoComplete="off"
                                                                ></input>
                                                                {validation.touched.description && validation.errors.description ? (
                                                                    <div id="description-error" className="mt-1 text-sm text-red-500">{validation.errors.description}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>



                                                        <div className="xl:col-span-4">
                                                            <label htmlFor="gender" className="inline-block mb-2 text-base font-medium">Gender</label>
                                                            <Select
                                                                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                                                options={GenderList}
                                                                defaultValue={selectedGender}
                                                                value={selectedGender}

                                                                isSearchable={true} // To disable search
                                                                name="gender"
                                                                id="gender"
                                                                onChange={e => { handleGenderSelection(e); console.log(e?.value) }}
                                                            />
                                                            {validation.touched.gender && validation.errors.gender ? (
                                                                <div id="gender-error" className="mt-1 text-sm text-red-500">{validation.errors.gender}</div>
                                                            ) : null}
                                                        </div>

                                                        <div className="xl:col-span-4">
                                                            <label htmlFor="seasonId" className="inline-block mb-2 text-base font-medium">Seasons</label>
                                                            <Select
                                                                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                                                options={seasons}
                                                                defaultValue={selectedSeasons}
                                                                value={selectedSeasons}
                                                                isSearchable={true} // To disable search
                                                                name="seasonId"
                                                                id="seasonId"
                                                                onChange={e => { handleSeasonSelection(e) }}
                                                            />
                                                            {validation.touched.seasonId && validation.errors.seasonId ? (
                                                                <div id="seasonId-error" className="mt-1 text-sm text-red-500">{validation.errors.seasonId}</div>
                                                            ) : null}
                                                        </div>

                                                        <div className="lg:col-span-2 xl:col-span-4">
                                                            <label htmlFor="availableFromDate" className="inline-block mb-2 text-base font-medium">Available From</label>
                                                            <Flatpickr
                                                                id="availableFromDate"
                                                                options={{
                                                                    altInput: true,
                                                                    altFormat: "d/m/Y",
                                                                    dateFormat: "m/d/Y",
                                                                }}
                                                                onChange={handleAvailableFromDateChange}
                                                                //onBlur={validation.handleBlur}
                                                                value={validation.values.availableFromDate || ""}

                                                                placeholder="available from date"
                                                                className="form-input border-slate-400 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                                            />



                                                            {validation.touched.availableFromDate && validation.errors.availableFromDate ? (
                                                                <div id="availableFromDate-error" className="mt-1 text-sm text-red-500">{validation.errors.availableFromDate}</div>
                                                            ) : null}
                                                        </div>

                                                        <div className="lg:col-span-2 xl:col-span-4">
                                                            <label htmlFor="availableToDate" className="inline-block mb-2 text-base font-medium">Available Till</label>
                                                            <Flatpickr
                                                                id="availableToDate"
                                                                options={{
                                                                    altInput: true,
                                                                    altFormat: "d/m/Y",
                                                                    dateFormat: "m/d/Y",
                                                                }}
                                                                onChange={handleAvailableToDateChange}
                                                                //onBlur={validation.handleBlur}
                                                                value={validation.values.availableToDate || ""}
                                                                placeholder="available till date"
                                                                className="form-input border-slate-400 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                                            />

                                                            {validation.touched.availableToDate && validation.errors.availableToDate ? (
                                                                <div id="availableToDate-error" className="mt-1 text-sm text-red-500">{validation.errors.availableToDate}</div>
                                                            ) : null}
                                                        </div>

                                                        <div className="xl:col-span-4">
                                                            <label htmlFor="packagingId" className="inline-block mb-2 text-base font-medium">Packaging</label>
                                                            <Select
                                                                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                                                options={packagings}
                                                                defaultValue={selectedPackagings}
                                                                value={selectedPackagings}
                                                                isSearchable={true} // To disable search
                                                                name="packagingId"
                                                                id="packagingId"
                                                                onChange={e => { validation.setFieldValue('packagingId', e?.value); setSelectedPackagings(e); console.log(e) }}
                                                            />
                                                            {validation.touched.packagingId && validation.errors.packagingId ? (
                                                                <div id="packagingId-error" className="mt-1 text-sm text-red-500">{validation.errors.packagingId}</div>
                                                            ) : null}
                                                        </div>

                                                        <div className="xl:col-span-4">
                                                            <label htmlFor="hsnsac" className="inline-block mb-2 text-base font-medium">
                                                                HSN-SAC {selectedHsnsac?.gstRate > 0 && " ,   GST - " + selectedHsnsac?.gstRate}
                                                            </label>
                                                            <div className="flex gap-2">
                                                                <input
                                                                    type="text"
                                                                    id="hsnsac"
                                                                    className="form-input border-slate-400 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 flex-1"
                                                                    value={selectedHsnsac?.label || ''}
                                                                    disabled
                                                                    placeholder="Select HSN-SAC"
                                                                />
                                                                <button
                                                                    type="button"
                                                                    onClick={() => setShowHsnsacPopup(true)}
                                                                    className="inline-flex items-center justify-center size-10 text-slate-500 transition-all duration-200 ease-linear bg-white border border-slate-200 rounded-md hover:bg-slate-50 dark:bg-zink-600 dark:border-zink-500 dark:hover:bg-zink-500/20"
                                                                >
                                                                    <svg className="size-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M19 9L12 16L5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                            {validation.touched.hsnsac && validation.errors.hsnsac ? (
                                                                <div id="hsnsac-error" className="mt-1 text-sm text-red-500">{validation.errors.hsnsac}</div>
                                                            ) : null}
                                                        </div>
                                                        <div className="xl:col-span-4">
                                                            <label htmlFor="hsnsac" className="inline-block mb-2 text-base font-medium">Add New HSN-SAC </label>
                                                            <br></br>
                                                            <button type="button" onClick={() => setShowHSNSACModal(true)} className="text-white bg-green-500 border-green-500 btn hover:text-white hover:bg-green-600 hover:border-green-600 focus:text-white focus:bg-green-600 focus:border-green-600 focus:ring focus:ring-green-100 active:text-white active:bg-green-600 active:border-green-600 active:ring active:ring-green-100 dark:ring-green-400/10">
                                                                + </button>
                                                        </div>
                                                        <div className="xl:col-span-8">
                                                            <label htmlFor="colors" className="inline-block mb-2 text-base font-medium">Colors Variant</label>
                                                            <div className="flex flex-wrap items-center gap-2 md:flex-nowrap md:flex-row md:gap-0 md:flex md:flex-wrap md:items-center md:justify-start">
                                                                <ProductColor
                                                                    id="colors"
                                                                    key="colorMain"
                                                                    onStatusChange={handleProductColorSelection}
                                                                    productColors={productColors}   
                                                                    onColorSaved={() => validation.handleSubmit()}
                                                                    showColorPallet={true}
                                                                    productVariants={productVariants}
                                                                ></ProductColor>
                                                                {validation.touched.colors && validation.errors.colors ? (
                                                                    <div id="colors-error" className="mt-1 text-sm text-red-500">{validation.errors.colors}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="xl:col-span-4">
                                                            <label htmlFor="colors" className="inline-block mb-2 text-base font-medium">Product Status</label>
                                                            <div className="flex flex-wrap items-center gap-2">

                                                                <div className="relative inline-block w-10 align-middle transition duration-200 ease-in ltr:mr-2 rtl:ml-2">
                                                                    <input
                                                                        type="checkbox"
                                                                        name="isActive"
                                                                        onChange={validation.handleChange}
                                                                        //onBlur={validation.handleBlur}
                                                                        value={validation.values.isActive}
                                                                        id="isActive"
                                                                        className="absolute block size-5 transition duration-300 ease-linear border-2 rounded-full appearance-none cursor-pointer border-slate-200 dark:border-zink-500 bg-white/80 dark:bg-zink-400 peer/published checked:bg-white dark:checked:bg-white ltr:checked:right-0 rtl:checked:left-0 checked:bg-none checked:border-custom-500 dark:checked:border-custom-500 arrow-none"
                                                                        defaultChecked
                                                                    />
                                                                    <label
                                                                        htmlFor="customDefaultSwitch"
                                                                        className="block h-5 overflow-hidden duration-300 ease-linear border rounded-full cursor-pointer cursor-pointertransition border-slate-200 dark:border-zink-500 bg-slate-200 dark:bg-zink-600 peer-checked/published:bg-custom-500 peer-checked/published:border-custom-500"
                                                                    ></label>

                                                                    {validation.touched.isActive && validation.errors.isActive ? (
                                                                        <div
                                                                            id="isActive-error"
                                                                            className="mt-1 text-sm text-red-500"
                                                                        >
                                                                            {validation.errors.isActive}
                                                                        </div>
                                                                    ) : null}
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div className="xl:col-span-12 flex justify-end gap-2">
                                                            <button type="reset" className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-700 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10">Reset</button>
                                                            {!isSaving ?
                                                                <button type="submit" className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                                                    {"Save Product"}
                                                                </button>
                                                                : <button type="button" disabled className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                                                    <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                                                                    Saving...
                                                                </button>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="xl:col-span-4">
                                            <div className="card bg-custom-50 dark:bg-custom-500/200">
                                                <div className="card-body">
                                                    <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12">
                                                        <div className="xl:col-span-12 border-b border-dashed">
                                                            <table className="w-full bg-custom-200 dark:bg-custom-500/10">
                                                                <thead className="ltr:text-left rtl:text-right bg-slate-200 dark:bg-slate-500/10">
                                                                    <tr>
                                                                        <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" style={{ width: 350 }}>Attribute</th>
                                                                        <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" style={{ width: 350 }}>Value</th>
                                                                        <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">Action</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >
                                                                            <Select
                                                                                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                                                                options={productAttributes}
                                                                                isSearchable={true} // To disable search
                                                                                name="attributeSelect"
                                                                                id="ageGroupSattributeSelectelect"
                                                                                onChange={e => { handleProductAttributeChange(e) }}
                                                                            />
                                                                        </th>
                                                                        <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" >
                                                                            <Select
                                                                                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                                                                options={productAttributeValues}
                                                                                isSearchable={true} // To disable search
                                                                                name="attributeValueSelect"
                                                                                id="attributeValueSelect"
                                                                                ref={productAttributeValueRef}
                                                                                onChange={e => { handleProductAttributeValueChange(e) }}
                                                                            />
                                                                        </th>
                                                                        <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">
                                                                            <button type="button" onClick={addProductAttributes} className="text-white bg-green-500 border-green-500 btn hover:text-white hover:bg-green-600 hover:border-green-600 focus:text-white focus:bg-green-600 focus:border-green-600 focus:ring focus:ring-green-100 active:text-white active:bg-green-600 active:border-green-600 active:ring active:ring-green-100 dark:ring-green-400/10">Add</button>
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {attributes?.map((attribute: any, index) => {
                                                                        return (<tr key={"tr_" + index + '-' + attribute.attributeValue.value} className="odd:bg-white even:bg-slate-50 dark:odd:bg-zink-700 dark:even:bg-zink-600">
                                                                            <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{attribute.attribute.label}</td>
                                                                            <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">{attribute.attributeValue.label}</td>
                                                                            <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                                                                                <Link to="#!"
                                                                                    className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-red-500 bg-red-100 hover:text-white hover:bg-red-500 dark:bg-red-500/20 dark:hover:bg-red-500"
                                                                                    onClick={() => {
                                                                                        onAttributeDelete(attribute.attributeValue.value);
                                                                                    }}><Trash2 className="inline-block size-4 ltr:mr-1 rtl:ml-1" /> </Link>
                                                                            </td>
                                                                        </tr>
                                                                        )
                                                                    })}

                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        {validation.touched.attributes && validation.errors.attributes ? (
                                                            <div id="attributes-error" className="mt-1 text-sm text-red-500">{validation.errors.attributes}</div>
                                                        ) : null}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </form>
                            </Tab.Pane>
                            <Tab.Pane eventKey="productImageBorderTop" id="productImageBorderTop" className="bg-slate-100">
                                <div className="card bg-custom-50 dark:bg-custom-500/200">
                                    <div className={`card-body ${productId ? '' : 'bg-gray-300 cursor-not-allowed'}`}>
                                        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12">
                                            <div className="xl:col-span-12" style={{ maxWidth: 500 }} >
                                                <label htmlFor="genderSelect" className="inline-block mb-2 text-base font-medium">Browse Images</label>

                                                <Dropzone
                                                    noClick={!productId}
                                                    onDrop={(acceptfiles: any) => {
                                                        handleAcceptfiles(acceptfiles);
                                                    }}>
                                                    {({ getRootProps, getInputProps }: any) => (
                                                        <div
                                                            className="flex items-center justify-center bg-white border border-dashed rounded-md cursor-pointer border-slate-300 dark:bg-zink-700 dark:border-zink-500 dropzone2"
                                                            style={{ height: 100 }}
                                                            {...getRootProps()}
                                                            {...(!productId && { onClick: () => commonHelper.showErrorMessage('Please save the product first before adding images.') })}
                                                        >
                                                            <input {...getInputProps()} />
                                                            <div className="py-5 text-lg text-center dz-message needsclick">
                                                                <UploadCloud className="block size-12 mx-auto text-slate-500 fill-slate-200 dark:text-zink-200 dark:fill-zink-500" />
                                                                <h5 className="mb-0 font-normal text-slate-500 dark:text-zink-200 text-15">Browse / Drop images</h5>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Dropzone>
                                            </div>
                                            <div className="xl:col-span-12" style={{ maxWidth: 500 }}>
                                                <div className="flex items-center space-x-3">

                                                    <label htmlFor="genderSelect" className="inline-block mb-2 text-base font-medium">Selected Images</label>

                                                    {loadingImage && <> <Loader2 className="size-4 animate-spin mb-2 ml-10" color="red" />
                                                        <label htmlFor="genderSelect" className="inline-block ml-2 mb-2 text-base font-medium">Uploading...</label>
                                                    </>}
                                                </div>
                                                <div className="xl:col-span-12 border-b border-dashed">
                                                    <table className="w-full bg-custom-50 dark:bg-custom-500/10">
                                                        <thead className="ltr:text-left rtl:text-right bg-slate-200 dark:bg-slate-500/10">
                                                            <tr>
                                                                <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" style={{ width: 350 }}>Image</th>
                                                                <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" style={{ width: 350 }}>Color</th>
                                                                <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900" style={{ width: 350 }}>Download</th>

                                                                <th className="px-3.5 py-2.5 font-semibold border-b border-custom-200 dark:border-custom-900">Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {productImages?.map((file: any, index) => {
                                                                return (<tr key={"tr_img_" + index + '-'} className="odd:bg-white even:bg-slate-50 dark:odd:bg-zink-700 dark:even:bg-zink-600">
                                                                    <td className="px-3 py-2 border-y border-custom-200 dark:border-custom-900">
                                                                        <div className="size-20 p-2 rounded-md bg-slate-100 dark:bg-zinc-600">
                                                                            <img className="block w-full h-full rounded-md" src={file.preview} alt={file.name} />
                                                                        </div>
                                                                    </td>
                                                                    <td className="px-3 py-2 border-y border-custom-200 dark:border-custom-900">
                                                                        <div className="flex items-center">
                                                                            <div
                                                                                style={{
                                                                                    background: file.colorCode || '#ffffff',
                                                                                    width: 35,
                                                                                    height: 35,
                                                                                    borderRadius: 5,
                                                                                    border: '1px solid #ccc',
                                                                                    marginRight: 8,
                                                                                    padding: 5,
                                                                                }}
                                                                                title={file.colorName || file.colorCode}
                                                                            >
                                                                                 <button
                                                                            type="button"
                                                                            title="Edit Color"
                                                                            onClick={() => handleEditColor(index, file)}
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                                </div>
                                                                            <span className="mr-2">{file.colorName}</span>
                                                                            {/* Edit Color Button */}

                                                                        </div>
                                                                   

                                                                        {/* Color Picker Modal */}
                                                                        {showColorModal && editingImageIndex === index && (
                                                                            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={handleCloseColorModal}>
                                                                                <div className="relative w-96 max-h-[400px] bg-white rounded-lg shadow-lg" onClick={e => e.stopPropagation()}>
                                                                                    <div className="p-4 border-b flex justify-between items-center">
                                                                                        <h3 className="text-lg font-semibold">Select Color</h3>
                                                                                        <button className="text-slate-400 hover:text-slate-700" onClick={handleCloseColorModal}>✕</button>
                                                                                    </div>
                                                                                    <div className="overflow-y-auto max-h-[300px] p-4 grid grid-cols-3 gap-4">
                                                                                        {/* Multi Color Box - Always Visible */}
                                                                                        <div
                                                                                            className={`flex flex-col items-center cursor-pointer border rounded p-2 relative ${tempSelectedColor?.colorCode === 'multi' ? 'border-blue-500' : 'border-slate-200'}`}
                                                                                            onClick={() => handleModalColorSelection({
                                                                                                colorCode: 'multi',
                                                                                                colorName: 'Multi Color',
                                                                                                isMultiColor: true,
                                                                                                selectedColors: productColors?.filter(c => c.selected) || []
                                                                                            })}
                                                                                        >
                                                                                            <div className="multi-color-box-container">
                                                                                                <div
                                                                                                    className="color-container"
                                                                                                    style={{
                                                                                                        width: 32,
                                                                                                        height: 32,
                                                                                                        borderRadius: 5,
                                                                                                        border: '1px solid #ccc',
                                                                                                        marginBottom: 4,
                                                                                                        position: 'relative',
                                                                                                    }}
                                                                                                >
                                                                                                    <div className="color-segments-container">
                                                                                                        {productColors?.filter(c => c.selected).map((color, index) => (
                                                                                                            <div
                                                                                                                key={index}
                                                                                                                className="color-segment"
                                                                                                                style={{
                                                                                                                    backgroundColor: color.colorCode,
                                                                                                                    borderRightWidth: index !== productColors.filter(c => c.selected).length - 1 ? '0.5px' : '0',
                                                                                                                    borderRightColor: 'rgba(0, 0, 0, 0.2)'
                                                                                                                }}
                                                                                                            />
                                                                                                        ))}
                                                                                                    </div>
                                                                                                    {tempSelectedColor?.colorCode === 'multi' && (
                                                                                                        <div className="checkmark-single" style={{
                                                                            position: 'absolute',
                                                                            top: '50%',
                                                                            left: '50%',
                                                                            transform: 'translate(-50%, -50%)',
                                                                            color: '#dbdbdb',
                                                                            fontSize: '12px',
                                                                            fontWeight: 'bold'
                                                                        }}>
                                                                                                            &#10004;
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                            <span className="text-xs">Multi Color</span>
                                                                                        </div>

                                                                                        {/* Individual Color Options */}
                                                                                        {productColors?.filter(c => c.selected).map((color, cidx) => (
                                                                                            <div
                                                                                                key={cidx}
                                                                                                className={`flex flex-col items-center cursor-pointer border rounded p-2 ${tempSelectedColor?.colorCode === color.colorCode ? 'border-blue-500' : 'border-slate-200'}`}
                                                                                                onClick={() => handleModalColorSelection(color)}
                                                                                            >
                                                                                                <div
                                                                                                    style={{
                                                                                                        background: color.colorCode,
                                                                                                        width: 32,
                                                                                                        height: 32,
                                                                                                        borderRadius: 5,
                                                                                                        border: '1px solid #ccc',
                                                                                                        marginBottom: 4,
                                                                                                        position: 'relative',
                                                                                                    }}
                                                                                                >
                                                                                                    {tempSelectedColor?.colorCode === color.colorCode && (
                                                                                                        <div className="checkmark-single" style={{
                                                                            position: 'absolute',
                                                                            top: '50%',
                                                                            left: '50%',
                                                                            transform: 'translate(-50%, -50%)',
                                                                            color: '#dbdbdb',
                                                                            fontSize: '12px',
                                                                            fontWeight: 'bold'
                                                                        }}>
                                                                                                            &#10004;
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                                <span className="text-xs">{color.colorName}</span>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                    <div className="p-4 border-t flex justify-end">
                                                                                        <button
                                                                                            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 mr-2"
                                                                                            onClick={() => handleCloseColorModal()}
                                                                                        >
                                                                                            Cancel
                                                                                        </button>
                                                                                        <button
                                                                                            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                                                                            onClick={handleSaveColor}
                                                                                            disabled={!tempSelectedColor?.colorCode && !tempSelectedColor?.isMultiColor}
                                                                                        >
                                                                                            Save
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </td>

                                                                    <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                                                                        <Link to={file.preview} target="_blank"
                                                                            className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-green-500 bg-green-100 hover:text-white hover:bg-green-500 dark:bg-green-500/20 dark:hover:bg-green-500"
                                                                        ><Download className="inline-block size-4 ltr:mr-1 rtl:ml-1" /> </Link>
                                                                    </td>
                                                                    <td className="px-3.5 py-2.5 border-y border-custom-200 dark:border-custom-900">
                                                                        <Link to="#!"
                                                                            className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-red-500 bg-red-100 hover:text-white hover:bg-red-500 dark:bg-red-500/20 dark:hover:bg-red-500"
                                                                            onClick={() => {
                                                                                deleteProductImage(index);
                                                                            }}><Trash2 className="inline-block size-4 ltr:mr-1 rtl:ml-1" /> </Link>
                                                                    </td>
                                                                </tr>
                                                                )
                                                            })}

                                                        </tbody>
                                                    </table>
                                                </div>

                                                {validation.touched.image && validation.errors.image ? (
                                                    <div id="image-error" className="mt-1 text-sm text-red-500">{validation.errors.image}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="productVariantBorderTop" id="productVariantBorderTop">
                                <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5"  >
                                    <div className="xl:col-span-12">
                                        <ProductVariant
                                            productName={memoizedProductName}
                                            productId={productId}
                                            ProductSizes={productSizes}
                                            ProductVariants={productVariants}
                                            ProductColors={memoizedProductColors}
                                            brandDiscount={brandDiscount}
                                            ProductImages={productImages}
                                            ProductSKU={memoizedProductSKU}
                                            CombinedColorItems={combinedColorItems}
                                        />
                                    </div>
                                </div>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>

                </div>
            </div>

            <Modal show={showHSNSACModal} onHide={() => setShowHSNSACModal(false)} id="defaultHSNSACModal" modal-center="true"
                className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600">
                {showHSNSACModal && <AddGTSRate onSave={onSaveHSNSAC} onHide={() => setShowHSNSACModal(false)} data={{}} />}
            </Modal>

            <HsnsacPopup
                show={showHsnsacPopup}
                onHide={() => setShowHsnsacPopup(false)}
                options={hsnsacList}
                onSelect={(option) => {
                    validation.setFieldValue('hsnsac', option.label);
                    setSelectedHsnsac(option);
                }}
                selectedValue={selectedHsnsac}
            />

        </React.Fragment>
    );
};

export default AddProduct;